module.exports = __webpack_public_path__ + "web/img/sign-50.f79bd8cd.png";